import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Sueño = () => {
  const [horaAcostarse, setHoraAcostarse] = useState('22:00');
  const [horaDespertarse, setHoraDespertarse] = useState('06:00');
  
  const calcularTiempoSueño = () => {
    const [h1, m1] = horaAcostarse.split(':').map(Number);
    const [h2, m2] = horaDespertarse.split(':').map(Number);
    let horas = h2 - h1;
    let minutos = m2 - m1;
    if (minutos < 0) {
      minutos += 60;
      horas -= 1;
    }
    if (horas < 0) {
      horas += 24;
    }
    return `${horas}h ${minutos}m`;
  };

  return (
    <div style={{ backgroundColor: '#F4F6FA', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <div style={{ padding: '20px', flex: 1 }}>
        <h2>Horario de Sueño</h2>
        <div style={{ margin: '10px 0' }}>
          <label>Hora de acostarse:</label>
          <input type="time" value={horaAcostarse} onChange={(e) => setHoraAcostarse(e.target.value)} />
        </div>
        <div style={{ margin: '10px 0' }}>
          <label>Hora de despertarse:</label>
          <input type="time" value={horaDespertarse} onChange={(e) => setHoraDespertarse(e.target.value)} />
        </div>
        <h3>Tiempo total de sueño: {calcularTiempoSueño()}</h3>
      </div>
      <Footer />
    </div>
  );
};

export default Sueño;
